/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import { v4 as uuidv4 } from "uuid";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
//service
import { newEvent } from "../../utils/services/events";
import { getUsers } from "../../utils/services/users";
import {
  createUserEvents,
  getUsersEvents,
} from "../../utils/services/usersEvents";
import { getProfiles } from "../../utils/services/profilesScreen";

import Select from "react-select";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

function ModalAddUsers(props) {
  const { isOpen, toggle, eventId } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isLoadingSelect, setIsloadingSelect] = useState(true);

  const [usersData, setUsersData] = useState([]);
  const [usersMulti, setUsersMulti] = useState([]);
  const [allUsers, setAllUsers] = useState(false);

  const [perfisData, setPerfisData] = useState([]);
  const [perfisMulti, setPerfisMulti] = useState([]);
  const [allPerfis, setAllPerfis] = useState(false);

  const [pristineUsers, setPristineUser] = useState(false);
  const [pristinePerfis, setPristinePerfis] = useState(false);

  const [success_dlg, setsuccess_dlg] = useState(false);

  const contractId = props.state.global_user_data.data.theme[0].id;

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  function handleSelectUser(e) {
    setselectedUser(e);
  }

  const submitForm = async () => {
    let allUsersIds = null;
    let allprofileIds = null;
    if (usersMulti.length > 0) {
      if (usersMulti[0].value === "todos") {
        allUsersIds = usersData?.map((e) => e.id);
      } else {
        allUsersIds = usersMulti?.map((e) => e.value);
      }
    }
    if (perfisMulti.length > 0) {
      if (perfisMulti[0].value === "todos") {
        allprofileIds = perfisData?.map((e) => e.id);
      } else {
        allprofileIds = perfisMulti?.map((e) => e.value);
      }
    }

    setIsloading(true);

    const objEventUsers = {
      eventId: eventId,
      loginId: allUsersIds,
      profileId: allprofileIds,
      contractId: contractId,
    };

    await createUserEvents(objEventUsers)
      .then((res) => {
        if (res.message === "created") {
          setIsloading(false);
          setsuccess_dlg(true);
        }
      })
      .catch((error) => {
        setIsloading(false);
        console.log("erro", error);
      });
  };

  const getEventsUsers = async () => {
    await getUsers({
      jwt: props.token,
      offset: 1,
      limit: 999,
      search: false,
      columnSearch: "showAllEvents",
    }).then((response) => {
      setUsersData(response?.findAllUsersData?.data);

      // setCountData(response?.findAllUsersData?.count);
    });
  };

  const getProfile = async () => {
    await getProfiles({
      offset: 1,
      limit: 999,
      search: contractId,
      columnSearch: "contractId",
    }).then((response) => {
      const filter = response?.data?.profiles
        ? response?.data?.profiles.filter((e) => !e.showAllEvents)
        : [];
      setPerfisData(filter);
      setIsloadingSelect(false);
    });
  };

  function handleUsersMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllUsers(true);
    } else {
      setAllUsers(false);
    }
    setUsersMulti(a);
  }

  function handlePerfisMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllPerfis(true);
    } else {
      setAllPerfis(false);
    }
    setPerfisMulti(a);
  }

  async function getEventsUsersPerfis() {
    var usersArray = [];
    var perfisArray = [];

    const userPerfisEvents = await getUsersEvents(eventId);

    if (userPerfisEvents?.data.length > 0) {
      const listUsers = userPerfisEvents.data.filter(
        (e) => e.loginId && !e.profileId
      );

      listUsers?.map((a) => {
        usersArray.push({ label: a.nome, value: a.loginId });
      });

      if (
        usersArray?.length > 0 &&
        usersData?.length > 0 &&
        usersData?.length === usersArray?.length
      ) {
        usersArray = [];
        usersArray.push({ label: "TODOS", value: "todos" });

        setAllUsers(true);
      }
      const listPerfis = userPerfisEvents.data.filter(
        (e) => !e.loginId && e.profileId
      );

      listPerfis?.map((a) => {
        perfisArray.push({ label: a.description, value: a.profileId });
      });

      if (perfisData?.length === perfisArray?.length) {
        perfisArray = [];
        perfisArray.push({ label: "TODOS", value: "todos" });

        setAllPerfis(true);
      }
    }

    setUsersMulti(usersArray);
    setPerfisMulti(perfisArray);

    setPristineUser(usersArray);
    setPristinePerfis(perfisArray);
  }

  useEffect(() => {
    getEventsUsers();
    getProfile();
  }, []);

  useEffect(() => {
    getEventsUsersPerfis();
  }, [usersData, perfisData]);

  function checkPristine(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;

    const sorted1 = [...arr1].sort((a, b) =>
      JSON.stringify(a).localeCompare(JSON.stringify(b))
    );
    const sorted2 = [...arr2].sort((a, b) =>
      JSON.stringify(a).localeCompare(JSON.stringify(b))
    );

    return sorted1.every(
      (obj, index) => JSON.stringify(obj) === JSON.stringify(sorted2[index])
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Cadastro"}
          onConfirm={() => {
            props.getAllEvents();
            setsuccess_dlg(false);
            toggle();
          }}
        >
          {"Usuários e Perfis cadastrados com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Adicionar Usuário ao Evento</ModalHeader>
      <ModalBody>
        <form>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <div>
                <label
                  className="form-label"
                  style={{ marginBottom: 10, display: "flex" }}
                >
                  Os perfis e usuários que podem visualizar todos os eventos não
                  serão exibidos na listagem.
                </label>
                <label
                  className="form-label"
                  style={{ marginBottom: 10, display: "flex" }}
                >
                  Usuários{" "}
                  <div
                    id="tooltipUser"
                    style={{ paddingRight: "7px", height: "16px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="tooltipUser"
                    >
                      Selecione um ou mais usuários para liberar a visualização
                      do evento.
                    </UncontrolledTooltip>
                  </div>
                </label>

                <Select
                  isLoading={isLoadingSelect}
                  value={usersMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleUsersMulti(e);
                  }}
                  options={[
                    {
                      options: !allUsers
                        ? [
                            { label: "TODOS", value: "todos" },
                            ...usersData.map((e) => {
                              return { label: e.nome, value: e.id };
                            }),
                          ]
                        : [],
                    },
                  ]}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  classNamePrefix="select2-selection"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: 150,
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: 150,
                      overflowY: "auto",
                    }),
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: 30 }}>
            <Col lg={12}>
              <div>
                <label
                  className="form-label"
                  style={{ marginBottom: 10, display: "flex" }}
                >
                  Perfis{" "}
                  <div
                    id="tooltipPerfis"
                    style={{ paddingRight: "7px", height: "16px" }}
                  >
                    <div className="show-tips">
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target="tooltipPerfis"
                    >
                      Selecione um ou mais perfis para liberar a visualização do
                      evento para todos os usuários do perfil.
                    </UncontrolledTooltip>
                  </div>
                </label>
                <Select
                  isLoading={isLoadingSelect}
                  value={perfisMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handlePerfisMulti(e);
                  }}
                  options={[
                    {
                      options: !allPerfis
                        ? [
                            { label: "TODOS", value: "todos" },
                            ...perfisData.map((e) => {
                              return { label: e.description, value: e.id };
                            }),
                          ]
                        : [],
                    },
                  ]}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  classNamePrefix="select2-selection"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: 150,
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: 150,
                      overflowY: "auto",
                    }),
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row
            style={{
              width: "100%",

              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={submitForm}
              action="U"
              marginLeft={10}
              isDisabled={
                checkPristine(pristineUsers, usersMulti) &&
                checkPristine(pristinePerfis, perfisMulti)
              }
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalAddUsers);
